module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_4.c0af15da.png";